/**
 * @param {string|undefined} code
 * @returns {string}
 */
export function toISOLanguageCode(code) {
    switch (code) {
        case 'en':
        case undefined:
            return 'en_US';
        default:
            return code + '_' + code.toUpperCase();
    }
}
